const Paths = {
  HOME: '/home',
  FORMS: '/forms',
  FORM: '/form',
  REPORT: '/report',
};

export default Paths;
